module.exports = __webpack_public_path__ + "img/laptop-code.a2efd1ec.svg";